// extracted by mini-css-extract-plugin
export default {"form":"form_form__v9NsD","regis":"form_regis__iYx2B"};